import { render, staticRenderFns } from "./v6.vue?vue&type=template&id=3813a8c1&"
import script from "./v6.vue?vue&type=script&lang=js&"
export * from "./v6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports